import {pluralNumber} from './pluralNumber';

export const monthsToYears = ( number ) => {
	const years = Math.floor( number / 12 );
	const months = number % 12;
	let text = `${years} ${pluralNumber( years, 'год', 'года', 'лет' )}`;
	
	if ( months > 0 )
	{
		text += ` ${months} мес`;
	}
	
	return text;
};
